module.exports = __webpack_public_path__ + "img/What-is-ai-th.7be97d3.png";